import {manageSubscriptionsStyles} from "@insite/content-library/Widgets/AccountSettings/AccountSettingsManageSubscriptions"
import { COLORS } from "@tCentro/theme/design"
import { css } from "styled-components"

manageSubscriptionsStyles.manageSubscriptionsTitle= {
    variant: "h4",
    as: "h2",
    css: css`
        margin-top: 15px !important;
    `
}

manageSubscriptionsStyles.manageSubscriptionsCheckbox= {
    css:css`
        span[role=checkbox] {
        border: 2px solid #9E9D9E !important;
        border-radius: 0 !important;
        &:focus {
            box-shadow: none !important;
        }
        &[aria-checked=true]{
            background: none !important;
            color: ${COLORS.black} !important;
            border: 2px solid ${COLORS.black} !important;
        }
}
    `,
    typographyProps: {
        css: css`
            margin-left: 10px;
        `,
    },
}